<iim-card [header]="supplierBasket?.supplier?.name" [ngClass]="{ 'basket-toggle-status': !basketToggleStatus }">
    @if (supplierBasket?.supplierNote && supplierBasket?.supplierNote?.note) {
        <div class="alert alert-info">
            <label class="me-2">{{ 'Bestellhinweis des Lieferanten' | translate }}:</label>
            <span>{{ supplierBasket?.supplierNote?.note }}</span>
        </div>
    }
    <div class="basket-supplier__delivery-condition-wrapper">
        <div class="basket-supplier__delivery-condition-wrapper-inner">
            @if (showDeliveryCondition) {
                <delivery-conditions
                    [editable]="true"
                    [condition]="deliveryCondition"
                    (onCreate)="create($event.value)"
                    (onUpdate)="update($event.value)"
                    (onDelete)="deleteCurrent()"
                ></delivery-conditions>
            }
            <basket-supplier-payment-term
                [paymentTerm]="supplierBasket?.paymentTerm"
                [paymentTermOptions]="paymentTerms"
                [editable]="true"
                [paymentTermRequired]="isPaymentTermRequired"
                [supplierCompanyId]="supplierBasket?.supplier?.id!"
                (paymentTermSelectionOpened)="onPaymentTermSelectionOpen()"
                (deleted)="deleteCurrentPaymentTerm()"
                (paymentTermValidated)="onPaymentTermValidated($event)"
            ></basket-supplier-payment-term>

            <basket-supplier-frame-contract-selection
                [frameContracts]="frameContracts"
                [frameContractSelection]="supplierBasket?.frameContract"
                [generalAgreementRequired]="generalAgreementRequired"
                [editable]="isEditableStep"
                (frameContractSelectionChanged)="onFrameContractSelectionChanged($event)"
                (frameContractValidated)="onFrameContractValidated($event)"
            ></basket-supplier-frame-contract-selection>
        </div>
    </div>

    @if (supplierBasket) {
        @if (basketItems && basketItems.length > 0) {
            @for (item of basketItems; track item.id) {
                <div>
                    <basket-supplier-item
                        [companySetting]="companySetting"
                        [parentSBId]="supplierBasket.id"
                        [supplierBasketItem]="item"
                        [isEditableStep]="isEditableStep"
                        [companyCodeId]="companyCodeId"
                        [resolvedPurchasingGroups]="resolvedPurchasingGroups"
                        [purchasingGroupVisible]="purchasingGroupVisible"
                        (basketItemDeleted)="deleteBasketItem($event)"
                        (productNumberValidationMessageShowed)="onShowProductNumberValidationMessage($event)"
                        (desiredDeliveryDateValidated)="onDesiredDeliveryDateValidated($event)"
                        (accountingValidated)="onAccountingValidated($event)"
                        (classificationValidated)="onClassificationValidated($event)"
                        (materialGroupValidated)="onMaterialGroupValidated($event)"
                        (siteValidated)="onSiteValidated($event)"
                    ></basket-supplier-item>
                    @if (budgetWarningsByItem.get(item.id?.toString()); as itemBudgetWarnings) {
                        <div class="alert alert-warning mt-2">
                            <strong class="me-2">⚠️ {{ 'Budget überschritten' | translate }}</strong>
                            <div class="d-flex flex-column">
                                @for (warning of itemBudgetWarnings; track warning.budgetId) {
                                    <div class="mb-1">
                                        <span class="fw-bold">{{ warning.budgetName }}</span>
                                        <span class="ms-2 text-muted">
                                            {{ 'Überschreitung' | translate }}:
                                            <display-currency [value]="warning.exceededAmount?.amount" [currencyCode]="warning.exceededAmount?.currency" />
                                        </span>
                                        <div class="small">
                                            @let warningCostCenter = getCostObject(budgetAssignmentType.COSTCENTER, warning.costObjects);
                                            @let warningProject = getCostObject(budgetAssignmentType.PROJECT, warning.costObjects);
                                            @let warningAccount = getCostObject(budgetAssignmentType.ACCOUNT, warning.costObjects);
                                            @if (warningCostCenter) {
                                                <span class="me-2">
                                                    {{ 'Kostenstelle' | translate }}: {{ warningCostCenter.name || warningCostCenter.key }}
                                                </span>
                                            }
                                            @if (warningProject) {
                                                <span class="me-2">
                                                    {{ 'Projekt' | translate }}: {{ warningProject.name || warningProject.key }}
                                                </span>
                                            }
                                            @if (warningAccount) {
                                                <span>
                                                    {{ 'Sachkonto' | translate }}: {{ warningAccount.name || warningAccount.key }}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        }

        <div class="basket-supplier__subtotal">
            <div class="basket-supplier__subtotal-label">
                <span class="basket-supplier__subtotal-title">{{ 'Zwischensumme Lieferant' | translate }}</span>
                <span
                    class="basket-supplier__subtotal-supplier"
                    [title]="
                        supplierBasket.supplier.name | supplierDisplayName: supplierBasket.supplier.supplierNumber
                    "
                >
                    {{
                        supplierBasket.supplier.name | supplierDisplayName: supplierBasket.supplier.supplierNumber
                    }}
                </span>
            </div>
            <div class="basket-supplier__subtotal-values">
                <div class="basket-supplier__subtotal-costs">
                    <div>
                        <span>{{ 'Lieferkosten' | translate }}</span>
                        <display-currency [value]="supplierBasket.totalFreightCosts.amount" [currencyCode]="supplierBasket.totalFreightCosts.currency" />
                    </div>
                    <div>
                        <span>{{ 'Zusatzkosten' | translate }}</span>
                        <display-currency [value]="0" [currencyCode]="supplierBasket.total.currency" />
                    </div>
                </div>
                <div class="basket-supplier__subtotal-amount">
                    <display-currency [value]="supplierBasket.total.amount" [currencyCode]="supplierBasket.total.currency" />
                </div>
            </div>
        </div>

        @if (isEditableStep && !isFreightCostOnlyItemForEverySupplier(supplierBasket)) {
            @let supplierMessageTitle =
                'Nachricht & Anhang an Lieferanten \{\{name\}\}' | translate: { name: supplierBasket.supplier.name };
            <div class="basket-supplier__footer">
                <div class="basket-supplier__footer-row">
                    <h3 class="basket-supplier__footer-title" [title]="supplierMessageTitle">
                        {{ supplierMessageTitle }}
                    </h3>
                    <div class="d-flex flex-wrap justify-content-end gap-2">
                        <button class="btn btn-outline-dark btn-sm" (click)="toggleCommentForSupplierTextarea()">
                            <em class="fas fa-comment pe-1"></em>
                            {{
                                showCommentForSupplierTextarea
                                    ? ('Nachricht ausblenden' | translate)
                                    : ('Nachricht an den Lieferanten' | translate)
                            }}
                        </button>
                        <button class="btn btn-outline-dark btn-sm" (click)="openAttachmentDialog(supplierBasket.id)">
                            <em class="fas fa-paperclip pe-1"></em>
                            {{ 'Datei anhängen' | translate }}
                        </button>
                    </div>
                </div>
                @if (showCommentForSupplierTextarea) {
                    <text-module-selection
                        [category]="textModuleCategoryEnum.ORDER"
                        (valueChange)="saveSupplierComment($event, supplierBasket.id)"
                        [value]="supplierBasket.commentForSupplier"
                        [title]="'Nachricht \{\{name\}\}' | translate: { name: supplierBasket.supplier.name }"
                    ></text-module-selection>
                }
                @if (supplierBasket?.attachments?.length) {
                    <div class="d-flex flex-column gap-2">
                        @for (file of supplierBasket.attachments; track $index) {
                            <file-download
                                [imagePreview]="true"
                                [file]="file"
                                [name]="file.fileName"
                                [removable]="isEditableStep"
                                (removeClicked)="deleteBasketAttachmentFile(file.id, supplierBasket.id)"
                            ></file-download>
                        }
                    </div>
                }
                <div class="basket-supplier__footer-row basket-supplier__footer-row--divided">
                    <h3 class="basket-supplier__footer-title">{{ 'Kommentar an Freigeber' | translate }}</h3>
                    <button class="btn btn-outline-dark btn-sm" (click)="toggleShowCommentForApproverTextarea()">
                        <em class="fas fa-comment pe-1"></em>
                        {{
                            showCommentForApproverTextarea
                                ? ('Kommentar ausblenden' | translate)
                                : ('Kommentar an den Freigeber' | translate)
                        }}
                    </button>
                </div>
                @if (showCommentForApproverTextarea) {
                    <text-module-selection
                        [category]="textModuleCategoryEnum.APPROVAL"
                        (valueChange)="savePersonComment($event, supplierBasket.id)"
                        [value]="supplierBasket.commentForApprover"
                        [title]="'Kommentar Freigeber' | translate"
                    ></text-module-selection>
                }
            </div>
        }

        @if (!isEditableStep && (supplierBasket.commentForSupplier || supplierBasket?.attachments?.length)) {
            @let readonlyMessageTitle =
                'Nachricht & Anhang an Lieferanten \{\{name\}\}' | translate: { name: supplierBasket.supplier.name };
            <div class="basket-supplier__footer">
                <div class="basket-supplier__footer-row">
                    <h3 class="basket-supplier__footer-title" [title]="readonlyMessageTitle">
                        {{ readonlyMessageTitle }}
                    </h3>
                </div>
                <textarea
                    readonly
                    matInput
                    class="form-control"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="15"
                    maxlength="65535"
                    >{{ supplierBasket.commentForSupplier }}</textarea
                >
                @if (supplierBasket?.attachments?.length) {
                    <div class="d-flex flex-column gap-2">
                        @for (file of supplierBasket.attachments; track $index) {
                            <file-download
                                [imagePreview]="true"
                                [file]="file"
                                [name]="file.fileName"
                                [removable]="isEditableStep"
                                (removeClicked)="deleteBasketAttachmentFile(file.id, supplierBasket.id)"
                            ></file-download>
                        }
                    </div>
                }
            </div>
        }

        @if (!isEditableStep && supplierBasket.commentForApprover) {
            <div class="basket-supplier__footer">
                <div class="basket-supplier__footer-row">
                    <h3 class="basket-supplier__footer-title">{{ 'Kommentar an Freigeber' | translate }}</h3>
                </div>
                <textarea
                    readonly
                    matInput
                    class="form-control"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="15"
                    maxlength="1000"
                    >{{ supplierBasket.commentForApprover }}</textarea
                >
            </div>
        }
    }
</iim-card>
